module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/printheader/printheader.component.css
// module id = ./src/app/printheader/printheader.component.css
// module chunks = main